import { immerOn } from 'ngrx-immer/store';
import { resetSort, setSort } from './sort.actions';
import { resetAllFilters } from '../filter.actions';
import { availableSortOptions } from './sort.state';
import { FilterState, SortState } from '@immosky/types';

export const initialSortState: SortState = {
  sort: availableSortOptions[0],
  default: availableSortOptions[0],
};

export const sortReducers = [
  immerOn(resetSort, resetAllFilters, (state: FilterState) => {
    state.sort.sort = state.sort.default;
  }),
  immerOn(setSort, (state: FilterState, { sort }) => {
    state.sort.sort = sort;
  }),
];
